import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query Categories {\n    categories(first: 100) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation CreateReview($input: ReviewInput!) {\n    reviewCreate(input: $input) {\n      errors {\n        field\n        message\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { TypedQuery } from "@temp/core/queries";
import gql from "graphql-tag";
import { TypedMutation } from "../../../core/mutations";
var createReviewMutation = gql(_templateObject());
var categoriesQuery = gql(_templateObject2());
export var TypedCreateReviewMutation = TypedMutation(createReviewMutation);
export var TypedCategoriesQuery = TypedQuery(categoriesQuery);